<template>
  <v-card class="account-details mb-1">
    <v-card-title>
      Summary Details
      <v-chip
        v-if="name"
        class="ma-2"
        color="lighten-1"
        :class="[name === 'dahabshiil.com' ? 'green' : 'blue']"
        label
        small
        text-color="white"
      >
        <v-icon left>
          mdi-link-variant
        </v-icon>
        {{ name }}
      </v-chip>
    </v-card-title>
    <ul class="report-details-list">
      <li
        v-for="(item, index) in safeGuardingTransactionSummaryFields"
        :key="index"
        class="report-details-list__item"
      >
        <b>{{ item.text }}</b>
        {{ data[item.value] }}
      </li>
    </ul>
  </v-card>
</template>

<script>
import {safeGuardingTransactionSummaryFields} from "@/utils/staticTablesColumns";

export default {
  name: 'CardTransactionsSummaryDetail',
  props: {
    name: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => {}
    },
  },
  created() {
    this.safeGuardingTransactionSummaryFields = safeGuardingTransactionSummaryFields;
  }
}
</script>
